import {Record as record} from 'immutable';
import _ from 'lodash';

import {resolve} from '../../helpers/LinkMapper';

const defaults = {
    customerId: null,
    customerName: null,
    email: null,
    smartcardNumber: null,
    smartcardStatus: null,
    isAdult: false
};

class SmartcardAccountInfo extends record(defaults) {
    static fromJSON(json = {}) {
        return new SmartcardAccountInfo({
            customerId: resolve(json.customerId).with(Number),
            customerName: resolve(json.customerName).with(String),
            email: resolve(json.email).with(String),
            smartcardNumber: resolve(json.smartcardNumber).with(String),
            smartcardStatus: resolve(json.smartcardStatus).with(String),
            isAdult: resolve(json.isAdult).with(Boolean)
        });
    }

    getCardNumber () {
        const { smartcardNumber } = this;
        const re = /(\d{6})(\d{4})(\d{4})(\d{4})/;
        const match = smartcardNumber && smartcardNumber.match(re);
        if (match) {
            return _.tail(match).join('-');
        }
        return null;
    }
}

export default SmartcardAccountInfo;



// WEBPACK FOOTER //
// ./src/records/customer/SmartcardAccountInfo.js